
export class User {
    id: string
    firstName: string
    lastName: string
    userName: string
    displayName: string
    email: string
    phone?: string
    password: string
    roleId: string
    image: string
    userType: number
}

export class UserBasicInfo{
    id: string
    userName: string
    displayName: string
    email: string
    phone?: string
    image: string
    primaryCityId: string
    secondaryCityId: string
    isAlumni: boolean
    isVerified: boolean
}

export class UpdateUserBasicInfoModel {
    phone: string
    primaryCityId: string
    secondaryCityId: string
    image: string
}

export class UpdateUserPasswordModel {
    oldPassword: string
    newPassword: string
    confirmNewPassword: string
}

export class UserVolunteerModel {
    id: string
    userName: string
    displayName: string
    email: string
    phone?: string
    birthDate: string
    image: string
    primaryCity: string
    secondaryCityId: string
    isAlumni: boolean
    isVerified: boolean
    education: []
    profession: []
    educationLevel: number
    professionType: number
    myRoles: []
}

export class UpgradeUserModel {
    id: string
    roleId: string
}